<template>
  <Modal
    v-model="visible"
    :title="title"
    :mask-closable="false"
    footer-hide
    width="700"
  >
    <div class="caring-contact-modal">
      <div style="display: flex;align-items: center">
        <AutoComplete
          v-model="search_text"
          placeholder="请输入姓名、工号模糊搜索"
        >
          <Option
            v-for="(i, index) in show_userlist"
            :value="i.id"
            :key="'doctor-' + i.id + '-' + index"
            :label="i.name + '（' + i.employee_id + '）'"
            @click.native="handleSelect(i)"
          >
            <span>{{ i.name }}({{ i.employee_id }})</span>
            <span style="float: right; color: #ccc">{{ i.dept_name }}</span>
          </Option>
        </AutoComplete>
        <el-button style="margin-left: 20px" size="small" type="primary" round @click="handleAddressDept">新增通讯录科室</el-button>
        <el-button style="margin-left: 20px" size="small" type="primary" round @click="handleAddressBook">新增通讯录成员</el-button>
      </div>
      <div class="selected-doctor-tags">
        <Tag
          color="blue"
          v-for="(i, index) in list"
          :key="'tag-' + i.id + '-' + index"
          style="margin-top: 5px; margin-right: 5px"
        >
          {{ i.name }}
          <Icon type="ios-close" @click.native="onDoctorChange(i)" />
        </Tag>
      </div>

      <div class="address-container">
        <!--左侧科室列表-->
        <div class="address-content">
          <div class="dept-list-search">
            <Input v-model="text" placeholder="请输入科室名称搜索" />
          </div>
          <div class="dept-list">
            <div
              class="dept-list-item"
              v-for="(i, index) in addressBook"
              :key="'dept-' + i.dept_id + '-' + index"
              v-if="
                !text.replace(/\s/g, '') ||
                i.dept_name.includes(text.replace(/\s/g, ''))
              "
            >
              <Checkbox
                :value="
                  getSelectedLength(i) === i.users.length && i.users.length > 0
                "
                :indeterminate="
                  getSelectedLength(i) !== i.users.length &&
                  getSelectedLength(i) > 0
                "
                :disabled="i.users.length === 0"
                @on-change="onDeptChange(i)"
              ></Checkbox>
              <span
                style="cursor: pointer"
                :class="{
                  'dept-list-item-active': choose_dept_id === i.dept_id,
                }"
                @click="choose_dept_id = i.dept_id"
              >
                {{ i.dept_name }}
                （{{ getSelectedLength(i) }}/{{ i.users.length }}）
              </span>
            </div>
            <div
              v-if="
                addressBook.filter(
                  (item) =>
                    !text.replace(/\s/g, '') ||
                    item.dept_name.includes(text.replace(/\s/g, ''))
                ).length === 0
              "
              style="text-align: center"
            >
              暂无结果
            </div>
          </div>
        </div>
        <!--右侧某科室下专家-->
        <div class="dept-choose-doctors">
          <!-- {{choose_dept}} -->
          <div
            class="doctor-list-item"
            v-for="(i, index) in (choose_dept && choose_dept.users) || []"
            :key="'doctor-' + i.id + '-' + index"
          >
            <Checkbox :value="isSelected(i)" @on-change="onDoctorChange(i)"
              >&nbsp;{{ i.name }} {{i.employee_id ? `(${i.employee_id})` : ''}}</Checkbox
            >
          </div>

          <div
            v-if="((choose_dept && choose_dept.users) || []).length === 0"
            style="line-height: 40px; text-align: center; color: #c5c8ce"
          >
            暂无数据
          </div>
        </div>
      </div>

      <div style="text-align: center; margin-top: 16px">
        <el-button type="info" round @click="visible = false">取消</el-button>
        <el-button type="primary" round  @click="submit">保存</el-button>
      </div>
    </div>
  </Modal>
</template>

<script>
import { ADDRESS_BOOK } from "../utils/env";
import storage from "store";
export default {
  name: "caring-contact-modal",
  data: function () {
    return {
      visible: false,
      list: [],
      text: "",
      choose_dept_id: "",
      search_text: "",
      addressBook: [],
      userlist: []
    };
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        const addressBook = storage.get(ADDRESS_BOOK + this.$store.state.user.user.id + this.$store.state.tenant.tenant);
        this.addressBook = addressBook;
        var userlist = [];
        addressBook.forEach((item) => {
          userlist = userlist.concat(item.users);
        });
        this.userlist = userlist;
      }
    }
  },
  computed: {
    show_userlist: function () {
      const search_text = (this.search_text + "").replace(/\s/g, "");
      if (!search_text) return [];
      return this.userlist.filter(
        (item) =>
          item.name.includes(search_text) ||
          (item.employee_id || '').includes(search_text)
      );
    },
    choose_dept: function () {
      var choose_dept = {};
      this.addressBook.forEach((item) => {
        if (item.dept_id === this.choose_dept_id) {
          choose_dept = item;
        }
      });
      return choose_dept;
    },
  },
  methods: {
    getDataByStorage() {
      const addressBook = storage.get(ADDRESS_BOOK + this.$store.state.user.user.id + this.$store.state.tenant.tenant);
      this.addressBook = addressBook;
      var userlist = [];
      addressBook.forEach((item) => {
        userlist = userlist.concat(item.users);
      });
      this.userlist = userlist;
    },
    handleAddressDept() {
      this.$emit("on-addressDept");
    },
    handleAddressBook() {
      this.$emit("on-addressBook");
    },
    handleSelect: function (doctor) {
      // console.log(item)
      this.search_text = "";
      this.onDoctorChange(doctor);
    },
    onDeptChange: function (dept) {
      // 选中or取消选中科室
      if (dept.users.length === 0) {
        this.$Message.warning("该科室下暂无可选专家");
        return;
      }
      if (this.getSelectedLength(dept) === dept.users.length) {
        // 已经全选
        dept.users.forEach((item) => {
          this.onDoctorChange(item);
        });
      } else {
        // 未全选，则全选
        dept.users.forEach((item) => {
          if (!this.isSelected(item)) {
            this.onDoctorChange(item);
          }
        });
      }
    },
    onDoctorChange: function (doctor) {
      // 选中or取消选中专家
      const doctor_index = this.list
        .map((item) => item.id + "")
        .indexOf(doctor.id + "");
      if (doctor_index < 0) {
        this.list.push(doctor);
      } else {
        this.list.splice(doctor_index, 1);
      }
    },
    getSelectedLength: function (dept) {
      // 判断科室下有多少已选专家
      return dept.users.filter((item) => {
        return this.isSelected(item);
      }).length;
    },
    isSelected: function (doctor) {
      // 判断专家是否被选
      return this.list.map((item) => item.id + "").includes(doctor.id + "");
    },
    show: function (list) {
      this.list = list;
      this.visible = true;
    },
    hide: function () {
      this.visible = false;
    },
    submit: function () {
      this.$emit("on-submit", this.list);
    },
  },
  mounted: function () {
    const addressBook = storage.get(ADDRESS_BOOK + this.$store.state.user.user.id + this.$store.state.tenant.tenant);
    this.choose_dept_id = addressBook && addressBook[0].dept_id;
  },
};
</script>

<style lang="less">
.caring-contact-modal {
  .selected-doctor-tags {
    margin-top: 8px;
    max-height: 150px;
    overflow: auto;
    .ivu-icon {
      color: #2d8cf0;
    }
  }
  .address-container {
    margin-top: 12px;
    display: flex;
    border-radius: 4px;
    border: solid 1px #dcdee2;
    .address-content {
      width: 0;
      flex: 1;
      border-right: solid 1px #dcdee2;
      .dept-list-search {
        padding: 10px 12px;
        border-bottom: solid 1px #dcdee2;
      }
      .dept-list {
        padding: 10px 12px;
        height: 400px;
        overflow-y: auto;
        background-color: #fff;
        .dept-list-item {
          height: 24px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          .dept-list-item-active {
            color: #2d8cf0;
            font-weight: bold;
          }
        }
      }
    }
    .dept-choose-doctors {
      flex: 1;
      padding: 10px 12px;
      overflow-y: auto;
      height: 453px;
      .doctor-list-item {
        height: 24px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
